module.exports = __webpack_public_path__ + "img/pic5_bg.401de69.png";